import Http from '../../../core/Http';

const publicUrlBase = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

export const HEADER_CONTENT_FALLBACK_URL = `${publicUrlBase}/assets/data/header/header-content-fallback.json`;

/**
 * 공개 헤더 문서 조회 (DB). 204/실패 시 null
 */
export async function fetchHeaderContentDocument(workplaceId = 1) {
  try {
    const data = await Http.get(`/api/comm/header-content/workspace/${workplaceId}/latest`);
    if (data == null || data === '' || (typeof data === 'object' && Object.keys(data).length === 0)) {
      return null;
    }
    return data;
  } catch (err) {
    const status = err?.response?.status;
    if (status === 204 || status === 404) return null;
    console.warn('[headerContentApi] API fetch failed:', err?.message);
    return null;
  }
}

export async function loadHeaderContentFallbackDocument() {
  try {
    const res = await fetch(HEADER_CONTENT_FALLBACK_URL, { cache: 'no-store' });
    if (!res.ok) {
      console.warn('[headerContentApi] fallback file HTTP', res.status, HEADER_CONTENT_FALLBACK_URL);
      return null;
    }
    const json = await res.json();
    if (!json?.headerContent?.headerData) return null;
    return json;
  } catch (e) {
    console.warn('[headerContentApi] fallback json load failed:', e?.message);
    return null;
  }
}

export async function fetchHeaderContentDocumentWithFallback(workplaceId = 1) {
  const apiDoc = await fetchHeaderContentDocument(workplaceId);
  if (apiDoc?.headerContent?.headerData) return apiDoc;

  const fallback = await loadHeaderContentFallbackDocument();
  if (fallback) {
    console.info('[headerContentApi] Using header-content-fallback.json (API empty or unavailable)');
    return fallback;
  }
  return null;
}
